import styled from "styled-components"

const StyledAIComment = styled.div`
  display: flex;
  padding: var(--spacing_s, 8px) var(--card_corner, 8px);
  align-items: flex-start;
  gap: var(--spacing_s, 8px);
  align-self: stretch;
  border-radius: var(--spacing_m, 12px);
  border: 0.5px solid var(--Primary_16, rgba(13, 163, 186, 0.16));
  background: var(
    --Gradient-bg-AI,
    linear-gradient(
      336deg,
      rgba(75, 217, 222, 0.27) 0%,
      rgba(75, 217, 222, 0) 100%
    ),
    linear-gradient(
      217deg,
      rgba(96, 243, 192, 0.27) 0%,
      rgba(75, 217, 222, 0) 70.71%
    ),
    linear-gradient(
      127deg,
      rgba(64, 247, 220, 0.27) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #fff
  );
`

const StyledAICommentText = styled.div`
  font-size: 14px;
  line-height: 140%;
  display: flex;
  padding: var(--spacing_s, 8px);
  align-items: flex-start;
  gap: var(--spacing_xxs, 4px);
  flex: 1 0 0;
  border-radius: var(--spacing_s, 8px);
  background: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  /* Drop Shadow */
  box-shadow: 0px 1px 6px 0px rgba(28, 31, 33, 0.06);
  color: #1c1f21;
`

const StyledIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: var(--Primitive-White, #fff);
`

const BigFitIcon = () => {
  return (
    <StyledIconWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="20"
        viewBox="0 0 25 20"
        fill="none"
      >
        <path
          d="M23.9086 19.8109C19.8307 19.8109 16.5137 16.4933 16.5137 12.4161V2.66772H20.1246V12.4161C20.1246 14.5027 21.8219 16.2001 23.9086 16.2001V19.8109Z"
          fill="black"
        />
        <path
          d="M7.63926 0.113037C3.56139 0.113037 0.244385 3.43066 0.244385 7.50792V19.2832H3.85526V7.50792C3.85526 5.42123 5.55258 3.72392 7.63926 3.72392V0.113037Z"
          fill="black"
        />
        <path
          d="M13.9803 7.76587H10.3694V19.2836H13.9803V7.76587Z"
          fill="black"
        />
        <path
          d="M6.33963 11.6422C7.41348 11.6422 8.284 10.7716 8.284 9.69779C8.284 8.62394 7.41348 7.75342 6.33963 7.75342C5.26579 7.75342 4.39526 8.62394 4.39526 9.69779C4.39526 10.7716 5.26579 11.6422 6.33963 11.6422Z"
          fill="#EF4D96"
        />
        <path
          d="M12.1751 6.47931C13.2489 6.47931 14.1194 5.60879 14.1194 4.53494C14.1194 3.4611 13.2489 2.59058 12.1751 2.59058C11.1012 2.59058 10.2307 3.4611 10.2307 4.53494C10.2307 5.60879 11.1012 6.47931 12.1751 6.47931Z"
          fill="#FA4614"
        />
        <path
          d="M22.6541 11.6422C23.7279 11.6422 24.5984 10.7716 24.5984 9.69779C24.5984 8.62394 23.7279 7.75342 22.6541 7.75342C21.5802 7.75342 20.7097 8.62394 20.7097 9.69779C20.7097 10.7716 21.5802 11.6422 22.6541 11.6422Z"
          fill="#2CCCD3"
        />
      </svg>
    </StyledIconWrapper>
  )
}

const AIComment = ({ comment }: { comment?: string }) => {
  if (!comment) return null
  return (
    <StyledAIComment>
      <BigFitIcon />
      <StyledAICommentText>{comment}</StyledAICommentText>
    </StyledAIComment>
  )
}

export default AIComment
